
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 36 36","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M17.977 36c9.928 0 17.977-8.049 17.977-17.977S27.904.047 17.977.047C8.049.047 0 8.095 0 18.023 0 27.951 8.049 36 17.977 36","fill":"#F44336"}}),_c('path',{attrs:{"d":"M18.385 11.299a7.072 7.072 0 00-7.086 7.086 7.087 7.087 0 006.753 7.08.32.32 0 00.333-.32v-2.078a.326.326 0 00-.296-.32 4.373 4.373 0 114.66-4.658.324.324 0 00.317.296h2.079a.32.32 0 00.32-.334 7.086 7.086 0 00-7.08-6.752m-.306 16.083a9.002 9.002 0 01-8.695-8.997c-.001-4.941 4.06-9.002 9.001-9.001a9.002 9.002 0 018.997 8.695.32.32 0 00.32.306h2.618a.32.32 0 00.318-.329c-.174-6.618-5.593-11.928-12.253-11.928A12.243 12.243 0 006.128 18.385c0 6.66 5.311 12.08 11.928 12.253a.32.32 0 00.33-.32V27.7a.318.318 0 00-.307-.318","fill":"#FFF"}})])])
          )
        }
      }
    